module.exports = __webpack_public_path__ + "static/media/AllFresco.ce1240fe.png";